export const MIN_SPINNER_MS = 300

/**
 * Milliseconds to wait so the refetch completes no earlier than MIN_SPINNER_MS after fetchStartedAtMs.
 * @param {number} fetchStartedAtMs
 * @returns {number}
 */
export function refetchRemainingMs(fetchStartedAtMs) {
    return Math.max(0, fetchStartedAtMs + MIN_SPINNER_MS - Date.now())
}

